module.exports = __webpack_public_path__ + "static/media/ESF.39738ee6.png";